import { APP_ROUTES } from "@/core/constants";
import type { AppRouteDefinition } from "@/core/router";

import { AccessPresetsPage } from "../views";

export const accessPresetsRoutes: readonly AppRouteDefinition[] = [
  {
    route: APP_ROUTES.superAdmin.accessPresets,
    element: <AccessPresetsPage />,
  },
] as const;
